export enum AgencyNumberEnum {
    Default = 2407757,
    Branch = 2407351,
    Advisor = 2407914,
    TESTD2C = 2408000,
}
